export default __webpack_public_path__ + "static/media/man-2.475f7830.jpg";